<script>
  import SegmentedControl from './segmented-control.svelte'

  let { value = $bindable(false), ...inputProps } = $props()

</script>

<SegmentedControl
  bind:value={value}
  options={[{ label: "No", value: false }, { label: "Yes", value: true }]}
  {...inputProps}
/>